import { Text } from 'foundations-components/components/Text';
import SanitizedText from 'sanitize-text/components/SanitizedText';
import { useSearchResultPageMetadata } from '../../hooks/useSearchResultPageMetadata';
import { useCollectionQuery } from '../../search-results/hooks/useCollectionQuery';
import { BaseHeader } from './BaseHeader';
import { jsx as _jsx } from "react/jsx-runtime";
export function SearchResultsPageHeader() {
  var _collectionResult$dat, _collectionResult$dat2;
  const collectionResult = useCollectionQuery();
  const {
    heading
  } = useSearchResultPageMetadata();

  // Determine collection name based on type
  const collectionName = collectionResult.isUmbrellaCollection ? (_collectionResult$dat = collectionResult.data) === null || _collectionResult$dat === void 0 ? void 0 : _collectionResult$dat.title : (_collectionResult$dat2 = collectionResult.data) === null || _collectionResult$dat2 === void 0 || (_collectionResult$dat2 = _collectionResult$dat2.publishedListing) === null || _collectionResult$dat2 === void 0 ? void 0 : _collectionResult$dat2.name;

  // Get collection description based on type
  const getCollectionDescription = () => {
    var _collectionResult$dat4;
    if (collectionResult.isUmbrellaCollection) {
      var _collectionResult$dat3;
      return (_collectionResult$dat3 = collectionResult.data) === null || _collectionResult$dat3 === void 0 ? void 0 : _collectionResult$dat3.description;
    } else if ((_collectionResult$dat4 = collectionResult.data) !== null && _collectionResult$dat4 !== void 0 && (_collectionResult$dat4 = _collectionResult$dat4.publishedListing) !== null && _collectionResult$dat4 !== void 0 && _collectionResult$dat4.metaDescription) {
      return collectionResult.data.publishedListing.metaDescription;
    } else {
      return null;
    }
  };
  const collectionDescription = getCollectionDescription();

  // Determine the title to show
  const getTitle = () => {
    if (collectionName) {
      return collectionName;
    }

    // Use the heading directly since it's already translated
    return /*#__PURE__*/_jsx(Text, {
      typography: "heading-600",
      children: heading
    });
  };
  return /*#__PURE__*/_jsx(BaseHeader, {
    dataTestId: "search-page-header",
    backBreadcrumb: !collectionName,
    title: getTitle(),
    subtitle: collectionDescription ? /*#__PURE__*/_jsx(Text, {
      color: "text-core-subtle",
      typography: "body-100",
      children: /*#__PURE__*/_jsx(SanitizedText, {
        body: collectionDescription,
        WrapperComponent: "span"
      })
    }) : undefined,
    pathKey: collectionName ? 'FEATURED_COLLECTION' : 'SEARCH_RESULTS'
  });
}